import apiFetch from '../apiFetch'

export default function (token, userId) {
  return apiFetch({ endPoint: `IdocMobile/getDeviceInstallations/${userId}`, method: 'GET', body: null, token: token })
}
